import type { Letter } from 'lib/api/themis/types';

// TODO: When using TS completely, remove this
// biome-ignore lint/suspicious/noExplicitAny: raw Themis API response shape isn't typed yet
const themisResponsetoLetters = (response: any[]): Letter[] => {
  const letters: Letter[] = response
    .map((letter) => ({
      correlationId: letter.correlationId,
      subject: letter.content.content.subject,
      message: letter.content.content.message.slice(0, 300),
      city: letter.content.sender.city,
      state: letter.content.sender.state,
      verifiedVoter: letter.content.sender.verifiedVoter || false,
      sentTimestamp: letter.sentTimestamp,
    }))
    .sort((a, b) => b.sentTimestamp - a.sentTimestamp);

  return letters;
};

// TODO: When using TS completely, remove this
// biome-ignore lint/suspicious/noExplicitAny: raw Themis API response shape isn't typed yet
const themisMessageReceiptEventToLetter = (letter: any): Letter => {
  return {
    correlationId: letter.correlationId,
    subject: letter.content.subject,
    message: letter.content.message.slice(0, 300),
    city: letter.sender.city,
    state: letter.sender.state,
    verifiedVoter: letter.sender.verifiedVoter || false,
    // These come in with a UTC timestamp, so we need to convert it
    sentTimestamp: new Date(letter.created).getTime() / 1000, // Convert ISO timestamp to Unix timestamp
  };
};

export { themisMessageReceiptEventToLetter, themisResponsetoLetters };
